/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
 */
const funHelper = {
  isInt: function (_val) {
    const regx = /^[1-9][0-9]*$/
    return regx.test(_val)
  },
  isNum: function (_val) {
    const regx = /^(-?\d+)(\.\d+)?$/
    return regx.test(_val)
  },
  // 去掉两头空格
  trim: function (_val) {
    return _val.replace(/^\s*|\s*$/g, '')
  },
  // 去掉左侧空格
  trimL: function (_val) {
    return _val.replace(/^\s*/g, '')
  },
  // 去掉右侧空格
  trimR: function (_val) {
    return _val.replace(/\s*$/g, '')
  },
  // 去掉所有空格
  trimAll: function (_val) {
    return _val.replace(/\s*/g, '')
  }

}

export default funHelper
